module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kat Brookes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Kat Brookes")]), _vm._v(" is an award-winning author and past Romance Writers of America Golden Heart Finalist. She pens stories of love, laughter and faith for both adult and young adult readers.  She is married to her childhood sweetheart and has been blessed with two beautiful daughters.  Kat is represented by Michelle Grajkowski with 3 Seas Literary Agency. Email: katbrookes@comcast.net .  Website: www.katbrookes.com.  Facebook: Kat Brookes."), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Pes4Ty/tc-custom/9781488007491.jpg?1738385891837",
      "alt": "This image is the cover for the book Her Texas Hero, Texas Sweethearts"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Texas Hero, Texas Sweethearts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this inspirational romance, a contractor rescues a single mother in need of home remodel and wonders if he can also be the family man she needs.")]), _c('br'), _c('br'), _vm._v("Seeking a fresh start, divorced single mom Audra Marshall uproots her family to a home she’s purchased sight unseen. But she hadn’t counted on the house needing major repairs. Enter handsome neighbor Carter Cooper. As a contractor, fixing houses is Carter’s job, but it turns into more than business when Audra allows him to help her rebuild her home. Carter’s soon falling for the sweet mom and her delightful kids. But Carter’s always been hesitant of opening his heart to love. As the cautious duo work together to transform her home, will they also find a love to last a lifetime?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0